import React from "react";
import { Switch, Route } from "react-router";
import ChoiceSteps from "./ChoiceSteps/ChoiceSteps";
import Welcome from "./Welcome/Welcome";

const SubjectChoiceRouter = () => {
    return (
        <Switch>
            <Route exact path={`/subject-choice`}>
                <Welcome />
            </Route>
            <Route exact path={`/subject-choice/selection`}>
                <ChoiceSteps />
            </Route>
        </Switch>
    );
};

export default SubjectChoiceRouter;
